/** Curated dev-user list matching backend DEFAULT_DEV_GROUPS. */
import type { DevUser } from "./types/chat";

export const DEV_USERS: DevUser[] = [
  {
    email: "compliance@example.test",
    label: "Compliance user",
    expectedGroups: ["group:compliance", "group:public"],
  },
  {
    email: "hr@example.test",
    label: "HR user",
    expectedGroups: ["group:hr", "group:public"],
  },
  {
    email: "leader@example.test",
    label: "Leader (HR + compliance + contracts)",
    expectedGroups: ["group:compliance", "group:contracts-confidential", "group:hr", "group:public"],
  },
  {
    email: "public@example.test",
    label: "Public-only user",
    expectedGroups: ["group:public"],
  },
  {
    email: "sales@example.test",
    label: "Sales (reads contracts)",
    expectedGroups: ["group:contracts-confidential", "group:public", "group:sales"],
  },
  {
    email: "admin@local.test",
    label: "Admin (local dev)",
    expectedGroups: ["group:admin", "group:compliance", "group:hr", "group:public"],
  },
  {
    email: "",
    label: "anonymous",
    expectedGroups: ["group:public"],
  },
];
